import React from 'react';
import { AnnouncementModalLayout, Box, Text } from '@wix/design-system';
import * as symbols from '@wix/santa-editor-symbols';
import * as panels from '#packages/panels';
import { translate } from '#packages/i18n';

export const MEMBER_AUTH_SUCCESS_MODAL_PANEL_NAME =
  'pageSettingsPanel.modals.memberAuthSuccessModal';

const BULLET_KEYS = [
  'member_authentication_app_success_modal_bullet1',
  'member_authentication_app_success_modal_bullet2',
  'member_authentication_app_success_modal_bullet3',
];

export interface MemberAuthSuccessModalProps {
  onOpenMemberAuth: () => void;
  onClose: () => void;
}

export const MemberAuthSuccessModal: React.FC<MemberAuthSuccessModalProps> = ({
  onOpenMemberAuth,
  onClose,
}) => (
  <panels.frames.FocusPanelFrame
    shouldHideHeader
    panelName={MEMBER_AUTH_SUCCESS_MODAL_PANEL_NAME}
    width="600px"
  >
    <AnnouncementModalLayout
      illustration={<symbols.symbol name="memberAuthSuccessIllustration" />}
      title={translate('member_authentication_app_success_modal_title')}
      primaryButtonText={translate(
        'member_authentication_app_success_modal_cta',
      )}
      primaryButtonOnClick={onOpenMemberAuth}
      onCloseButtonClick={onClose}
    >
      <Box paddingLeft="24px" paddingRight="24px" textAlign="start">
        <Text size="small">
          <ul>
            {BULLET_KEYS.map((bulletKey) => (
              <li key={bulletKey}>{translate(bulletKey)}</li>
            ))}
          </ul>
        </Text>
      </Box>
    </AnnouncementModalLayout>
  </panels.frames.FocusPanelFrame>
);
